import _slicedToArray from "/builds/webservices/sites/campaigns-cigna-com/node_modules/@babel/runtime/helpers/esm/slicedToArray";
export default function () {
  if (location.pathname.includes('/2018/individuals-families/mycigna/onboarding')) {
    var alertCTA = document.querySelector('.accordion-content .bg-digital-blue-10 .link-action');
    var event = document.createEvent('HTMLEvents');
    event.initEvent('click', true, false);
    alertCTA.addEventListener('click', function (e) {
      e.preventDefault();

      var _document$querySelect = document.querySelectorAll('.accordion-title-single'),
          _document$querySelect2 = _slicedToArray(_document$querySelect, 2),
          step1 = _document$querySelect2[0],
          step2 = _document$querySelect2[1];

      step1.dispatchEvent(event);
      step2.dispatchEvent(event);
    });
  }
}